import type {
  AdhesionDetailResponseDTO,
  AdhesionListRequest,
  AdhesionListResponse,
  DownloadAdhesionDetailRequestDTO,
} from '../../types/previdencia/previdenciaType';
import { PREVIDENCIA_DOWNLOAD_ADHESION_ROUTES } from '../requestsService';

export class AdhesionService {
  private fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>;

  constructor(fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>) {
    this.fetch = fetch;
  }

  /**
   * List adhesions by company / subcompany (paginated)
   * Matches backend endpoint: GET /v1/previdencia/adhesions
   * @param params - Request parameters
   */
  async listAdhesions(params: AdhesionListRequest): Promise<AdhesionListResponse> {
    const queryParams = new URLSearchParams();

    queryParams.append('companyId', params.companyId);
    queryParams.append('subCompanyId', params.subCompanyId);

    if (params.dateFrom) {
      queryParams.append('dateFrom', params.dateFrom);
    }
    if (params.dateTo) {
      queryParams.append('dateTo', params.dateTo);
    }
    if (params.status) {
      queryParams.append('status', params.status);
    }
    if (params.page !== undefined) {
      queryParams.append('page', params.page.toString());
    }
    if (params.size !== undefined) {
      queryParams.append('size', params.size.toString());
    }

    const url = `${PREVIDENCIA_DOWNLOAD_ADHESION_ROUTES.GET_LIST_ADHESIONS}?${queryParams.toString()}`;

    return this.fetch<AdhesionListResponse>(url, {
      method: 'GET',
    });
  }

  /**
   * Get adhesion detail
   * Matches backend endpoint: GET /v1/previdencia/adhesions/detail
   * @param adhesionId - Adhesion ID
   */
  async getAdhesionDetail(
    adhesionId: number
  ): Promise<AdhesionDetailResponseDTO> {
    const url = `${PREVIDENCIA_DOWNLOAD_ADHESION_ROUTES.GET_ADHESION_DETAIL}?adhesionId=${encodeURIComponent(adhesionId)}`;

    return this.fetch<AdhesionDetailResponseDTO>(url, {
      method: 'GET',
    });
  }

  /**
   * Download adhesion detail
   * Matches backend endpoint: POST /v1/previdencia/adhesions/download
   * @param request - Download request data
   */
  async downloadAdhesionDetail(
    request: DownloadAdhesionDetailRequestDTO
  ): Promise<void> {
    return this.fetch<void>(PREVIDENCIA_DOWNLOAD_ADHESION_ROUTES.POST_DOWNLOAD_ADHESION, {
      method: 'POST',
      body: JSON.stringify(request),
    });
  }
}